/*
 * Public API Surface of ng2-tooltip-directive
 */

export * from './lib/tooltip.component';
export * from './lib/tooltip.directive';
export * from './lib/tooltip.module';
export * from './lib/tooltip-options.interface';